import { lazyRetry } from "../../helpers/lazyRetry";

const Deposits_L = lazyRetry(() => import("./DepositsPage"));

export default Deposits_L;
